import type { ViewModelId, EditingUserJSON } from 'balus-common';
import { useSetAtom } from 'jotai/react';
import { useSnapshot } from '@framework/hooks/useSnapshot';
import { RTDBPath } from 'balus-common';
import { EditingUser } from '@model-framework/text';
import type { EditingUsers } from './editingUsersAtom';
import { editingUsersAtom } from './editingUsersAtom';
import { toast } from 'react-hot-toast';
import { t } from 'i18next';

// ノードを編集しているユーザを取得してatomに読み込む
export function EditingUsersLoader({ viewModelId }: { viewModelId: ViewModelId }) {
  const setEditingUsers = useSetAtom(editingUsersAtom);

  useSnapshot({
    path: RTDBPath.ViewModelViewer.editingUsersPath(viewModelId),
    load({ getChildValues }) {
      const values = getChildValues() as Record<string, EditingUserJSON>;
      const editingUsers = Object.entries(values).reduce<EditingUsers>((acc, [key, value]) => {
        if (value) {
          acc[key] = EditingUser.load(value);
        }
        return acc;
      }, {});
      setEditingUsers(editingUsers);
    },
    stateless: true,
    onError: () => {
      toast.error(t('common.message.loadFailed'));
    },
  });

  return null;
}
